export enum StatusDotStatus {
  online = 'online',
  offline = 'offline',
}

export interface StatusDotProps {
  className?: string;
  status: StatusDotStatus;
  testId?: string;
}
